import React, { useState } from "react";
import Timer from "./Timer";
import styles from "../styles/ControlPanel.module.css";

function ControlPanel({
  handleNewGame,
  handleInstructions,
  handleTimer,
  handleHighscoreBoard,
  moves,
  newGame,
  setIsCompeting,
  hasWon,
  time,
  setTime
}) {
  const [timer, setTimer] = useState(false);
  

  function handleNewGameClick() {
    handleNewGame();
  }

  function handleInstructionClick() {
    handleInstructions();

    // const scrollInstructions = (instructionsRef) =>{
    //   window.scrollTo({
    //     // top: instructionsRef.offsetTop,
    //     top: 2000,
    //     left: 0,
    //     behavior: "smooth",
    //   });
    // };

    // const scrollIntoView = (instructionsRef) => {
    //   instructionsRef.current.scrollIntoView({
    //     top:500,
    //     behavior:"smooth",
    //     block:"start",
    //   })
    // }
    // //scrollIntoView(scrollInstructionsRef);
    //  scrollInstructions(scrollInstructionsRef.current);
  }

  function handleTimerClick() {
    //handleTimer();
    setTimer(!timer);
  }
  function handleHighscoreBoardClick() {
    handleHighscoreBoard();
    // const anchor = document.querySelector("#highscoreBoard");
    // anchor.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  return (
    <div className={styles.container}>
      
      <div className={styles.controlPanelContainer}>
        <button className={styles.newGameButton} onClick={handleNewGameClick}>
          New Game
        </button>
        <button
          className={styles.instructionButton}
          onClick={handleInstructionClick}
        >
          <a href="#instructions">Instructions</a>
        </button>
        <button className={styles.timerButton} onClick={handleTimerClick}>
          Timer
        </button>
        {
          <button
            className={styles.highscoresButton}
            onClick={handleHighscoreBoardClick}
          >
            <a href="#highscoresBoard">Highscores</a>
          </button>
        }
      </div>
      <div className={styles.timerControlContainer}>
        <Timer
          timer={timer}
          newGame={newGame}
          moves={moves}
          setIsCompeting={setIsCompeting}
          hasWon={hasWon}
          time={time}
          setTime={setTime}
        ></Timer>
      </div>
    </div>
  );
}
export default ControlPanel;
